import { Component } from '@angular/core';
import { ThemeService } from '../../shared/services/theme.service';
import { RouterOutlet } from '@angular/router';

interface AgendaSlot {
  time: string;
  service?: string;
  detail?: string;
  tone?: string;
  isNew?: boolean;
}

@Component({
  selector: 'app-auth-layout',
  imports: [RouterOutlet],
  templateUrl: './auth-layout.html',
  styleUrl: './auth-layout.css',
})
export class AuthLayout {
  /** Sample day shown beside the forms, dated today so it reads as the user's own agenda */
  readonly today = AuthLayout.describeToday();

  readonly slots: AgendaSlot[] = [
    { time: '9:00', service: 'Corte y barba', detail: 'Andrés con Camilo', tone: '#9aa8ff' },
    { time: '10:00', service: 'Manicure semipermanente', detail: 'Laura con Sofía', tone: '#7dd3bf' },
    { time: '11:30', service: 'Limpieza facial', detail: 'Reservó en línea hace 2 min', tone: '#ffd25e', isNew: true },
    { time: '13:00', service: 'Masaje relajante', detail: 'Valentina con Mateo', tone: '#f5a3bd' },
    { time: '15:00' },
  ];

  constructor(public darkModeService: ThemeService) {}

  toggleDarkMode() {
    this.darkModeService.toggleDarkMode();
  }

  private static describeToday() {
    const now = new Date();
    const part = (options: Intl.DateTimeFormatOptions) => now.toLocaleDateString('es', options);
    return {
      weekday: part({ weekday: 'long' }),
      day: part({ day: 'numeric' }),
      month: part({ month: 'long' }),
    };
  }
}
